<template>
    <div class="col-md-12">
        <br />
        <form @submit.prevent="searchData()" role="form">
            <div class="row">
                <div class="col-2">

                    <input type="text"
                           class="form-control input-sm"
                           v-model="pagingInfo.search"
                           placeholder="Search..." />

                </div>
                <div class="col-2">

                    <select id="region"
                            class="form-control"
                            v-model="pagingInfo.mydata">
                        <option value="0">All Data</option>
                        <option value="1">My Encodes</option>
                    </select>

                </div>
                <div class="col-2">

                    <button type="submit" class="btn btn-info ">
                        <strong>Search</strong>
                    </button>&nbsp;
                    <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>

                </div>
            </div>
        </form>
        <br />

        <div class="box">
            <div class="box-header"></div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                Organization Name
                            </th>
                            <th>Other Name</th>
                            <th>Comments</th>
                            <th>Created By</th>
                            <th>
                                Date Created
                            </th>
                            <th>Updated By</th>
                            <th>Date Updated</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, index) in organizations" :key="user.id">
                            <td>{{ user.title }}</td>
                            <td>{{ user.otherName }}</td>
                            <td>{{ user.comments | capitalize }}</td>
                            <td>{{ user.createdBy }}</td>
                            <td>{{ user.dateCreated | formatDate }}</td>
                            <td>{{ user.updatedBy }}</td>
                            <td>{{ user.dateUpdated | formatDate }}</td>
                            <td v-if="$store.getters.LINKMODE">
                                <button class="btn btn-sm btn-success"
                                        @click="setLink(user.id)">
                                    Link Object
                                </button>
                            </td>

                            <td v-else-if="$store.getters.CRAD">
                                <TheDropDownButton>
                                    <btn @click.native="deleteOrg(user.id, index)"
                                         icon="fa fa-trash"
                                         title="Delete"></btn>
                                    <btn @click.native="editOrg(user.id)"
                                         icon="fa fa-pencil-alt"
                                         title="Edit"></btn>
                                    <btn @click.native="addtoMerge(user)"
                                         icon="fa fa-code-branch"
                                         title="Merge Record"></btn>
                                    <btn @click.native="requestlinkdownload(user.id)"
                                         icon="fa fa-cloud-download-alt"
                                         title="Export"></btn>
                                    <btn @click.native="attachSOIOrg(user.id)"
                                         icon="fa fa-upload"
                                         title="Profile/SOI Upload"></btn>
                                    <btn @click.native="soidb(user.id)"
                                         icon="fa fa-file"
                                         title="View SOI from database"></btn>
                                    <btn @click.native="sois(user.id)"
                                         icon="fa fa-download"
                                         title="View Downloadable Profile"></btn>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>

                                    <btn @click.native="startLink(user)"
                                         icon="fa fa-compress"
                                         title="Enable Link Mode"></btn>
                                </TheDropDownButton>
                            </td>
                            <td v-else-if="$store.getters.VIEWER">
                                <TheDropDownButton>
                                    <btn @click.native="soidb(user.id)"
                                         icon="fa fa-file"
                                         title="View SOI from database"></btn>
                                    <btn @click.native="sois(user.id)"
                                         icon="fa fa-download"
                                         title="View Downloadable Profile"></btn>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                </TheDropDownButton>
                            </td>
                            <td v-else>
                                <TheDropDownButton>
                                    <btn v-if="mydata"
                                         @click.native="editOrg(user.id)"
                                         icon="fa fa-pencil-alt"
                                         title="Edit"></btn>
                                    <btn @click.native="attachSOIOrg(user.id)"
                                         icon="fa fa-upload"
                                         title="Profile/SOI Upload"></btn>
                                    <btn @click.native="soidb(user.id)"
                                         icon="fa fa-file"
                                         title="View SOI from database"></btn>
                                    <btn @click.native="sois(user.id)"
                                         icon="fa fa-download"
                                         title="View Downloadable Profile"></btn>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>

                                    <btn @click.native="startLink(user)"
                                         icon="fa fa-compress"
                                         title="Enable Link Mode"></btn>
                                </TheDropDownButton>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>
                <div v-show="totalitems == 0" class="alert alert-warning">
                    <p>Found no result try again</p>
                </div>
            </div>
        </div>

        <b-pagination v-model="pagingInfo.page"
                      v-on:input="fetchData()"
                      :total-rows="totalitems"
                      :per-page="pagingInfo.itemsPerPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"></b-pagination>
        <!-- Modal For Uploaded SOI -->
        <div>
            <b-modal id="orgsoi" title="Uploaded SOI" scrollable hide-footer>
                <TheSoiProfileOrg v-bind:id="soiId" />
            </b-modal>
        </div>
        <!-- Modal For SOI from DB -->
        <div>
            <b-modal id="orgsoifromdb"
                     title="FullText SOI"
                     scrollable
                     hide-footer
                     size="xl">
                <span v-html="soifromdb"></span>
            </b-modal>
        </div>
        <div>
            <b-modal id="LinkPopupOG" title="Link Builder" scrollable hide-footer>
                <LinkPopUp />
            </b-modal>
            <b-modal id="EditPopUPOG"
                     title="Edit Oganization"
                     size="lg"
                     scrollable
                     hide-footer>
                <EditOrg v-bind:id="OrgId" v-on:done-edit-org="doneEdit()" />
            </b-modal>

            <b-modal id="attachsoiorg"
                     title="Profile/SOI Upload"
                     scrollable
                     hide-footer
                     size="md">
                <attachSOIORG v-bind:id="orgIdAttach"
                              v-bind:url="urlAttach"
                              v-on:done-edit-att="doneEditAtt()" />
            </b-modal>
            <b-modal id="linkpopuporg" size="xl" scrollable hide-footer>
                <LinkComponentPopOrg v-bind:id="linkid"
                                     v-bind:linkdescription="linkdescription" />
            </b-modal>
            <b-modal id="mergerecordorg"
                     size="md"
                     hide-footer
                     ref="merger"
                     no-close-on-esc="true"
                     no-close-on-backdrop="true"
                     hide-header-close="true">
                <MergepopUpog v-bind:obj1ID="obj1Id"
                            v-bind:obj2ID="obj2Id"
                            v-bind:obj1Desc="obj1description"
                            v-bind:obj2Desc="obj2description"
                            v-bind:objType="objType"
                            v-on:done="done()"
                            v-on:cancel="cancel()" />
            </b-modal>
        </div>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        RecordURL,
        notifyHelper,
        setObject2Link,
        RequestLink,
    } from "../helper";
    import LinkPopUp from "./master/Linking";
    import EditOrg from "./edit/Organization";
    import btn from "./buttons/iconButton";
    import attachSOIORG from "./master/editAttachment";
    import TheSoiProfileOrg from "./master/soiProfile";
    import LinkComponentPopOrg from "./link/linkcomponent";
    import MergepopUpog from "./master/recordMerge";
    import instance from "../helper/http";
    export default {
        data() {
            return {
                soifromdb: "",
                soi: [],
                organizations: [],
                pagingInfo: {
                    page: 1,
                    sortBy: "Name",
                    reverse: false,
                    search: "",
                    mydata: 0,
                },
                totalitems: null,
                OrgId: "",
                mydata: false,
                urlAttach: "attachSOI",
                orgIdAttach: "",
                soiId: "",
                linkid: "",
                linkdescription: "",
                obj1Id: "",
                obj2Id: "",
                objType: "",
                obj1description: "",
                obj2description: "",
                hasfirst: false,
            };
        },
        components: {
            LinkPopUp,
            EditOrg,
            btn,
            attachSOIORG,
            TheSoiProfileOrg,
            LinkComponentPopOrg,
            MergepopUpog,
        },
        methods: {
            async requestlinkdownload(id) {
                await RequestLink(id);
            },
            clearControls() {
                this.pagingInfo.search = "";
            },
            fetchData() {
                if (this.pagingInfo.mydata == "0") this.mydata = false;
                else this.mydata = true;

                instance
                    .get(RecordURL + "getorg", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.organizations = response.data.data;
                        this.totalitems = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                        this.mydata = false;
                        this.organizations = [];
                        this.totalitems = 0;
                    });
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            More: function (data) {
                var additional =
                    (data.title ? data.title : "") +
                    " " +
                    (data.otherName ? data.otherName : "");
                additional = additional.replace(/\//g, "-");
                this.linkid = data.id;
                this.linkdescription = additional;
                this.$bvModal.show("linkpopuporg");
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            addtoMerge(data) {
                var additional =
                    (data.title ? data.title : "") +
                    " " +
                    (data.otherName ? data.otherName : "");
                additional = additional.replace(/\//g, "-");
                if (this.hasfirst) {
                    if (this.obj1Id == data.id) {
                        notifyHelper("info", "Cannot merge the same organization");
                    }
                    else {
                        this.obj2description = additional;
                        this.obj2Id = data.id;
                        this.objType = "OG"
                        this.$bvModal.show("mergerecordorg");
                    }
                } else {
                    this.obj1description = additional;
                    this.obj1Id = data.id;
                    this.hasfirst = true;
                    notifyHelper(
                        "success",
                        "Add to merging of record, please choose another record to merge"
                    );
                }
            },
            cancel() {
                this.$bvModal.hide("mergerecordorg");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
            },
            done() {
                this.$bvModal.hide("mergerecordorg");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
                this.fetchData();
            },
            sois: function (id) {
                this.soiId = id;
                this.showModal();
            },
            showModal: function () {
                this.$bvModal.show("orgsoi");
            },
            soidb: function (id) {
                instance
                    .get(RecordURL + "soidb?id=" + id + "&type=OG", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.withsoi) {
                            this.soifromdb = response.data.data;
                            this.$bvModal.show("orgsoifromdb");
                        } else {
                            notifyHelper("warn", "SOI from database not found");
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            setLink: function (id) {
                setObject2Link(id, "OG");
                this.$bvModal.show("LinkPopupOG");
            },
            editOrg: function (id) {
                this.OrgId = id;
                //modal
                this.$bvModal.show("EditPopUPOG");
            },
            doneEdit() {
                this.$bvModal.hide("EditPopUPOG");
            },

            deleteOrg: function (id, index) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to delete?.", {
                        title: "Delete?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            instance
                                .get(RecordURL + "deleteOrg?orgID=" + id, {
                                    headers: authHeader(),
                                })
                                .then((response) => {
                                    if (response.data.error) {
                                        notifyHelper("error", response.data.message);
                                        
                                    } else {
                                        notifyHelper("success", response.data.message);
                                        this.organizations.splice(index, 1)
                                    }
                                })
                                .catch(function (error) {
                                    responseCheck(error.response.status);
                                });
                        }
                    });
            },
            attachSOIOrg: function (doc) {
                this.orgIdAttach = doc;
                //modal
                this.$bvModal.show("attachsoiorg");
            },
            doneEditAtt() {
                this.$bvModal.hide("attachsoiorg");
            },
            startLink: function (doc) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to enable link mode?.", {
                        title: "Enable Link Mode?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            var additional =
                                "Organization: " +
                                (doc.title === null ? " " : doc.title) +
                                " Other Name: " +
                                (doc.otherName === null ? " " : doc.otherName)
                            this.$store.commit("enablelinkMode", {
                                id: doc.id,
                                type: "OG",
                                description: additional,
                            });
                        }
                    });
                //.catch((err) => {});

                // if (confirm("Activate link mode?")) {

                // }
            },

        },
    };
</script>